export const COMPONENT_CRASH = 'Component-Crash';
export const NOT_FOUND = 'Not-Found';
export const INVALID_TEST_CODE = 'Invalid-Test-Code';
export const GET_API_ERROR = 'Get-Api-Error';
export const INIT_REWARD_SPONSOR = 'Init-Reward-Sponsor';
export const INIT_REWARD_PROMO = 'Init-Reward-Promo';
export const INIT_API_TIMEOUT = 'Init-Api-Timeout';
// Init API 逾時後，該請求最終的結局（resolved / rejected）；用於回推真實耗時，非故障訊號
export const INIT_API_TIMEOUT_OUTCOME = 'Init-Api-Timeout-Outcome';
export const GET_USER_LATEST_ENTRIES = 'Get-User-Latest-Entries';
export const CREATE_ENTRIES = 'Create-Entries';
export const CREATE_ENTRIES_TURNSTILE_VERIFICATION_FAILED =
    'Create-Entries-Turnstile-Verification-Failed';
export const GET_HAS_GAME_RESULT_RECORDS = 'Get-Has-Game-Result-Records';
export const CHECK_REDUCE_POINT_STATUS = 'Check-Reduce-Point-Status';
export const CHECK_PASSCODE_STATUS = 'Check-Passcode-Status';
export const SUBMIT_PASSCODE = 'Submit-Passcode';
export const VERIFY_PASSCODE = 'Verify-Passcode';
export const POINT_API = 'Point-Api';
export const GET_KKBOX_USER_POINT = 'Get-KKbox-User-Point';
export const REDUCE_KKBOX_POINT = 'Reduce-KKbox-Point';
export const GET_WINNER = 'Get-Winner';
export const PRIZE_REDEEM_WITHDRAW_NOT_FOUND = 'Prize-Redeem-Withdraw-Not-Found';
export const GET_WINNER_TASK = 'Get-Winner-Task';
export const GET_WINNER_QUALIFY = 'Get-Winner-Qualify';
export const PICK_PRIZE_LOTTERY_NO_REMAINDER = 'Pick-Prize-Lottery-No-Remainder';
export const JOIN_GAME = 'Join-Game';
export const JOIN_PURE_PRIZE_GAME = 'Join-Pure-Prize-Game';
export const JOIN_GAME_ENTRY_ALREADY_SUBMITTED = 'Join-Game-Entry-Already-Submitted';
export const INVOICE_VALIDATION = 'Invoice-Validation';
export const PURCHASE_REWARD_SUBMIT_DEAD_LOCK = 'Purchase-Reward-Submit-Dead-Lock';
export const PURCHASE_REWARD_SUBMIT_FAILED = 'Purchase-Reward-Submit-Failed';
export const PURCHASE_REWARD_ENTRY_NOT_FOUND = 'Purchase-Reward-Entry-Not-Found';
export const REDEEM_FORM = 'Redeem-Form';
export const SIGNUP_FORM = 'Signup-Form';
export const FILL_FORM_DUPLICATE = 'Fill-Form-Duplicate';
export const GET_FORM_REDIRECT_URL = 'Get-Form-Redirect-Url';
export const RESULT_PAGE = 'Result-Page';
export const PRIZE_PAGE_WINNER_INFO = 'Prize-Page-Winner-Info';
export const INVALID_PRIZE_PAGE_WINNER_INFO = 'Invalid-Prize-Page-Winner-Info';
export const PRIZE_OPEN_WINNER = 'Prize-Open-Winner';
export const PRIZE_PAGE_GET_CODE = 'Prize-Page-Get-Code';
export const PRIZE_PAGE_STORE_REDEEM = 'Prize-Page-Store-Redeem';
export const PLAY_NEW_ENTRIES = 'Play-New-Entries';
export const PUSH_REDEEM_PRIZE_URL = 'Push-Redeem-Prize-Url';
export const LOGIN_LONG_TERM_FAILED = 'Login-Long-Term-Failed';
export const LOGIN_GET_ACCESS_TOKEN_FAILED_REWARD_INIT =
    'Login-Get-Access-Token-Failed-Reward-Init';
export const LOGIN_GET_ACCESS_TOKEN_FAILED_CARRIER_AUTHORIZATION_INIT =
    'Login-Get-Access-Token-Failed-Carrier-Authorization-Init';
export const LIFF_INIT_FAILED = 'Liff-Init-Failed';
export const UGC_SUBMIT_VOTE = 'Ugc-Submit-Vote';
export const LINE_FRIEND_QUALIFY_VALIDATION_FAILED = 'Line-Friend-Qualify-Validation-Failed';
export const MEMORY_MATCH_START_GAME_FAILED = 'Memory-Match-Start-Game-Failed';
export const GET_MEMBER_POINT_FAILED = 'Get-Member-Point-Failed';
export const GET_POINT_POOL_INFO_FAILED = 'Get-Point-Pool-Info-Failed';
export const TRANSACTION_WITHDRAW_QUANTITY_IS_WRONG = 'Transaction-Withdraw-Quantity-Is-Wrong';
export const DEDUCT_POINT_FAILED = 'Deduct-Point-Failed';
export const PHOTO_MERGE_FAILED = 'Photo-Merge-Frame-Failed';
export const UPLOAD_FILE_FAILED = 'Upload-File-Failed';
// 發票 AI 辨識：「請求沒送到 / 沒回來」與「後端有回應但沒辨識出資訊」必須分開，
// 前者換幾張圖都不會過，後者才該請使用者重拍。#86eyxwtty
export const INVOICE_OCR_REQUEST_FAILED = 'Invoice-Ocr-Request-Failed';
export const INVOICE_OCR_NOT_RECOGNIZED = 'Invoice-Ocr-Not-Recognized';
// 後端明確回覆辨識不出發票（400 + RCP-V0-F0）屬已知的預期結果，不回報 Sentry。#z8udzkkx9j
export const INVOICE_OCR_KNOWN_NOT_RECOGNIZED = 'Invoice-Ocr-Known-Not-Recognized';
export const SUBMIT_REFERRIAL_CODE_FAILED = 'Submit-Referral-Code-Failed';
export const MGM_LOTTERY_VALIDATION_FAILED = {
    REFERRAL_ENTRY_NOT_FOUND: 'Mgm-Lottery-Validation-Failed-By-ReferralEntry-Not-Found',
    EXCEPTION: 'Mgm-Lottery-Validation-Failed'
};
export const MGM_CREATE_ENTRY_FAILED = 'Mgm-Create-Entry-Failed';
export const GET_API_ERROR_AND_NO_REFRESH_BTN = 'Get-Api-Error-And-No-Refresh-Btn';
export const SHARE_TARGET_PICKER_OPEN_FAILED = 'Share-target-picker-open-failed';
export const SHARE_TARGET_PICKER_INIT_FAILED = 'Share-target-picker-init-failed';
export const INFINITE_SCROLL = 'infinite-scroll';
export const WINNER_NOT_FOUND = 'Winner-Not-Found';
export const FORM_DATA_WINNER_NOT_FOUND = 'Form-Data-Winner-Not-Found';
export const POINTS_IS_NOT_ENOUGH_BY_PRE_CHECK =
    'Promotion status is Pause - points is not enough by pre-check';
export const POINTS_IS_NOT_ENOUGH = 'Promotion status is Pause - points is not enough';
export const FAILED_TO_FETCH = 'Failed-To-Fetch';
export const FAILED_TO_LOAD = 'Failed-To-Load';
export const CHUNK_LOAD_FAILED = 'Chunk-Load-Failed';
export const PREFLIGHT_RESPONSE_IS_NOT_SUCCESSFUL = 'Preflight-Response-Is-Not-Successful';
export const NOT_ALLOWED_BY_ACCESS_CONTROL_ALLOW_ORIGIN =
    'Not Allowed By Access Control Allow Origin';
export const DNS_LOOK_UP_FAILED = 'DNS-Look-Up-Failed';
export const SSL_CONNECTION_ERROR = 'SSL-Connection-Error';
export const WEB_KIT_ERROR = 'Web-Kit-Error';
export const PROMO_NOT_FOUND = 'Promo-Not-Found';
export const LIFF_INIT_AUTH_FAILED = 'Liff-Init-Auth-Failed';
export const UGC_GET_MEDIA_COUNTS = 'Ugc-Get-Media-Counts';
export const ORDER_REWARD_API_ERROR = 'Order-Reward-Api-Error';
export const ORDER_REWARD_THIRD_PARTY_API_ERROR = 'Order-Reward-Third-Party-Api-Error';
export const ORDER_REWARD_ENTRY_NOT_FOUND = 'Order-Reward-Entry-Not-Found';
export const CART_REWARD_THIRD_PARTY_API_ERROR = 'Cart-Reward-Third-Party-Api-Error';
export const ENTRY_FLOW_HAS_GAME_RESULT = 'Entry-Flow-Has-Game-Result';
export const CHECK_POINT_CARD_FAILED = 'Check-Point-Card-Failed';
export const CHECK_TASK_COMPLETED_RECORD_FAILED = 'Check-Task-Completed-Record-Failed';
export const TASK_AND_RELATED_PROMO_DISCONNECT = 'Task-And-Related-Promo-Disconnect';
export const STORE_GAME_RESULT_ENTRY_FLOW_EXISTS = 'Store-Game-Result-Entry-Flow-Exists';
export const STORE_GAME_RESULT_ENTRY_TOTAL_LIMIT = 'Store-Game-Result-Entry-Total-Limit';
export const STORE_ENTRY_SHARE_RECORD_FAILED = 'Store-Entry-Share-Record-Failed';
export const POINT_IS_LOCKED = 'Point-Is-Locked';
export const THIRD_PARTY_API_TIMED_OUT = 'Third-Party-Api-Timed-Out';
export const LOGIN_USER_INFO_FAILED = 'Login-User-Info-Failed';
export const SURVEY_RESULT_PAGE_FAILED = 'Survey-Result-Game-Failed';
export const TOKEN_ERROR = 'Token-Error';
export const LOGIN_BY_LIFF_TOKEN_ERROR = 'Login-By-Liff-Token-Error';
export const LIFF_VERIFY_MEMBER_BIND_OCEP_ERROR = 'Liff-Verify-Member-Bind-Ocep-Error';
export const LOGIN_BY_LIFF_TOKEN_INFO_API_ERROR = 'Login-By-Liff-Token-Info-Api-Error';
export const LOGIN_BY_LIFF_TOKEN_INFO_PARSE_ERROR = 'Login-By-Liff-Token-Info-Parse-Error';
export const LIFF_GET_LINE_TOKEN_FAILED = 'Liff-Get-Line-Token-Failed';
export const NOTIFY_EMAIL_NOT_VALID = 'Notify-Email-Not-Valid';
export const NOTIFY_CREATE_FAILED = 'Notify-Create-Failed';
export const NOTIFY_MISSING_REQUIRED_FIELDS = 'Notify-Missing-Required-Fields';
export const AI_FAILED_WITH_PROMO_END = 'AI-Failed-With-Promo-End';
export const AI_FAILED_WITH_RETRY_AI_JOBS = 'AI-Failed-With-Retry-AI-Jobs';
export const NOTIFY_CREATE_FAILED_BUT_NO_SENTRY = 'Notify-Create-Failed-But-No-Sentry';
export const ENTRY_REACH_TOTAL_LIMIT = 'Entry-Reach-Total-Limit';
export const GET_ENTRY_RECORD_RESULT_FAILED = 'Get-Entry-Record-Result-Failed';
export const GET_AI_JOBS_FAILED = 'Get-AI-Jobs-Failed';
export const RETRY_AI_JOB_FAILED = 'Retry-AI-Job-Failed';
export const JOB_IS_NOT_FOUND = 'Job-Is-Not-Found';
export const MISSION_REWARD_DATE_FORMAT_ERROR = 'Mission-Reward-Date-Format-Error';
export const PRIZE_REDEEM_RUNOUT = 'Prize-Redeem-Runout';
export const REDEEM_POINT_FAILED = 'Redeem-Point-Failed';
export const REDEEM_POINT_IS_NOT_ENOUGH = 'Redeem-Point-Is-Not-Enough';
export const OPTION_NOT_FOUND = 'Option-Not-Found';
export const ACHIEVEMENT_PAGE_INIT_FAILED = 'Achievement-Page-Init-Failed';
export const ACHIEVEMENT_STATUS_IS_NOT_ENABLED = 'Achievement-Status-Is-Not-Enabled';
export const GET_ACHIEVEMENT_MEMBER_INFO_FAILED = 'Get-Achievement-Member-Info-Failed';
export const CALLED_EMPTY_PARAMS_URL = 'Called-Empty-Params-URL';
// 導頁到揭曉頁時 caller 沒帶 lottery uuid（定位用，見 useClientHistory 的 LOTTERY case）
export const ANIMATING_LOTTERY_UUID_MISSING = 'Animating-Lottery-Uuid-Missing';
export const AI_WEB_GAME_IFRAME_LOAD_ERROR = 'AI-Web-Game-Iframe-Load-Error';
// 遊戲 document 已在跑（收到 bridge 心跳），只是子資源（Sponsor 圖片）拖過了 load 逾時。
// 獨立一個 errType 讓它在 Sentry 自成一個 issue，不與「document 沒跑」的真故障混在一起（#86eyw7bwq）。
export const AI_WEB_GAME_IFRAME_LOAD_SLOW = 'AI-Web-Game-Iframe-Load-Slow';
// blob: iframe 8 秒內沒有 load、也沒收到 bridge 心跳（多半是客戶 App 的 WKWebView 或 iOS
// 內容阻擋器把 blob: 擋掉），已自動改用 srcdoc 重試一次。warning 級；
// 兩種模式都失敗才會走 LOAD_ERROR（#86eyxwpm9）。
export const AI_WEB_GAME_IFRAME_LOAD_FALLBACK = 'AI-Web-Game-Iframe-Load-Fallback';
export const AI_WEB_GAME_RUNTIME_ERROR = 'AI-Web-Game-Runtime-Error';
// 遊戲有送 GAME_READY，只是晚於保底揭露。慢不是故障，獨立 errType 以免淹沒真正的
// 契約違反（#86eyxhbpx）
export const AI_WEB_GAME_READY_LATE = 'AI-Web-Game-Ready-Late';
// 遊戲宣告 waitForGameReady 卻始終沒送 GAME_READY＝契約沒實作（#86eyxhbpx）
export const AI_WEB_GAME_READY_MISSING = 'AI-Web-Game-Ready-Missing';
export const AI_WEB_GAME_START_API_ERROR = 'AI-Web-Game-Start-Api-Error';
export const AI_WEB_GAME_VALIDATION_ERROR = 'AI-Web-Game-Validation-Error';
// 注入的 meta CSP 擋掉了遊戲想載的資源。相容性遙測，不是資安告警（#86eykupwd）
export const AI_WEB_GAME_CSP_VIOLATION = 'AI-Web-Game-CSP-Violation';
export const PROMO_PRIZE_LIST_FETCH_FAILED = 'Promo-Prize-List-Fetch-Failed';
export const TURNSTILE_GRACEFUL_DEGRADATION = 'Turnstile-Graceful-Degradation';
export const GET_MEMBER_TAGS_AUTH_FAILED = 'Get-Member-Tags-Auth-Failed';
export const GET_MEMBER_TAGS_FAILED = 'Get-Member-Tags-Failed';
export const SEQUENTIAL_TASK_NOT_UNLOCKED = 'Sequential-Task-Not-Unlocked';
